import { memo } from 'react';
import { message, Row, Col } from 'antd';
import SurveysService from '../SurveysService';

import styles from './report.module.css';
import Dashboard from './Dashboard';
import { ReportProps } from './Report';
import { useQuery } from '@tanstack/react-query';

type ReportDashboardsProps = Omit<ReportProps, 'questions'> & {
  onDataLoaded: () => void;
};

const ReportDashboards = ({
  client,
  surveyId,
  filters,
  onDataLoaded,
}: ReportDashboardsProps) => {
  const queryData = async () => {
    let data = await SurveysService.getSurveyDashboards(client, surveyId);
    return data;
  };

  const { isLoading, data: dashboards } = useQuery(
    ['survey_dashboards', surveyId],
    queryData,
    {
      onSettled: onDataLoaded,
      onError: (err) => {
        console.error(err);
        message.error((err as any).message);
      },
    }
  );

  if (dashboards && dashboards.length > 0) {
    return (
      <div className={styles.customDashboards}>
        <Row gutter={16}>
          {dashboards.map((d: any, idx: number) => (
            <Col
              key={d.id}
              xs={24}
              sm={24}
              md={d.flex}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <Dashboard
                client={client}
                surveyId={surveyId}
                filters={filters}
                dashboard={d}
                index={idx}
                loading={isLoading}
                alternate_colors={d.type === 'Column' && d.order === 1}
              />
            </Col>
          ))}
        </Row>
      </div>
    );
  } else return <></>;
};

export default memo(ReportDashboards);
